(() => {
  if (window.filazooProductZoomCursorInitialized) return;
  window.filazooProductZoomCursorInitialized = true;

  const zoomRatio = 2.5;

  document.addEventListener('pointermove', (event) => {
    if (event.pointerType && event.pointerType !== 'mouse') return;

    const opener = event.target.closest('.filazoo-main-product .product__modal-opener--image');
    if (!opener) return;

    const lens = opener.querySelector('.filazoo-product-zoom-lens');
    const image = opener.querySelector('.product__media img');
    if (!lens || !image) return;

    const openerBounds = opener.getBoundingClientRect();
    const imageBounds = image.getBoundingClientRect();
    const x = event.clientX - imageBounds.left;
    const y = event.clientY - imageBounds.top;

    if (x < 0 || y < 0 || x > imageBounds.width || y > imageBounds.height) {
      lens.classList.remove('is-active');
      return;
    }

    const source = image.currentSrc || image.src;
    if (lens.dataset.source !== source) {
      lens.style.backgroundImage = `url("${source.replace(/"/g, '\\"')}")`;
      lens.dataset.source = source;
    }

    lens.style.left = `${event.clientX - openerBounds.left}px`;
    lens.style.top = `${event.clientY - openerBounds.top}px`;
    lens.style.backgroundSize = `${imageBounds.width * zoomRatio}px ${imageBounds.height * zoomRatio}px`;
    lens.style.backgroundPosition = `${lens.offsetWidth / 2 - x * zoomRatio}px ${lens.offsetHeight / 2 - y * zoomRatio}px`;
    lens.classList.add('is-active');
  });

  document.addEventListener('pointerout', (event) => {
    const opener = event.target.closest?.('.filazoo-main-product .product__modal-opener--image');
    if (!opener || opener.contains(event.relatedTarget)) return;
    opener.querySelector('.filazoo-product-zoom-lens')?.classList.remove('is-active');
  });
})();
